import React from "react";
import Background from "images/404_not_found_background.png";
import Typography from "ui/Typography";
import Link from "ui/Link";
import ImgIceCream from "images/dropped-ice-cream.png";
import ImgIceCream2x from "images/dropped-ice-cream@2x.png";
import HelpCircleSolid from "ui/Icons/HelpCircleSolid";
import styled from "styled-components/macro";
import { theme } from "ui/theme";
import { HelpLinks } from "utils/helpLinks";

const $Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  justify-content: center;
  background: url("${Background}");
  background-size: cover;
  gap: 1rem;
  text-align: center;

  @media screen and (${theme.BreakpointTabletDown}) {
    padding: 0 1rem;
  }
`;

const $DroppedIceCream = styled.img.attrs({
  role: "presentation",
  src: ImgIceCream,
  srcSet: `${ImgIceCream2x} 2x`,
})`
  margin-bottom: 2rem;
`;

const $Window = styled.div`
  background-color: ${theme.ColorWhite};
  border-radius: ${theme.RadiusMd};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 3rem;
  margin-top: 1rem;

  @media screen and (${theme.BreakpointTabletDown}) {
    padding: 1rem 1.5rem;
  }
`;

const $HelpCircle = styled(HelpCircleSolid).attrs({
  size: "sm",
  role: "presentation",
})`
  margin-right: 0.5rem;

  @media screen and (${theme.BreakpointTabletDown}) {
    display: none;
  }
`;

export default function ErrorPage() {
  return (
    <$Wrapper>
      <$DroppedIceCream />
      <Typography size="h2">Something went wrong</Typography>
      <Typography size="bodySerif">
        Try{" "}
        <Link
          onClick={() => window.location.reload()}
          analyticsName="clicked_reload_from_error"
        >
          refreshing the page
        </Link>{" "}
        or checking back later.
      </Typography>
      <$Window>
        <$HelpCircle />
        <Typography size="bodySerif">
          <Link
            analyticsName="clicked_contact_support_from_error"
            href={HelpLinks.NEW_REQUEST}
            opensInNewTab={true}
          >
            Contact support if this problem persists
          </Link>
        </Typography>
      </$Window>
    </$Wrapper>
  );
}
